import clsx from 'clsx';

import { PRESET_LABELS, moscowToday, presetPeriod, type PeriodPreset, type PeriodValue } from '@/lib/period';

const PRESETS: PeriodPreset[] = ['month', 'prev', 'quarter', 'year', 'custom'];

/** Быстрые периоды и свои даты. Даты — по московскому календарю. */
export default function PeriodPicker({ value, onChange }: { value: PeriodValue; onChange: (v: PeriodValue) => void }) {
  const today = moscowToday();
  const pick = (preset: PeriodPreset) => {
    if (preset === 'custom') onChange({ ...value, preset });
    else onChange(presetPeriod(preset, today));
  };

  return (
    <div className="space-y-2">
      <div className="-mx-4 flex gap-1.5 overflow-x-auto px-4 pb-1 sm:mx-0 sm:flex-wrap sm:px-0" role="group" aria-label="Период">
        {PRESETS.map((p) => (
          <button
            key={p}
            type="button"
            aria-pressed={value.preset === p}
            onClick={() => pick(p)}
            className={clsx(
              'shrink-0 rounded-full border px-3 py-1.5 text-sm font-medium transition-colors min-h-[36px]',
              value.preset === p
                ? 'border-ink bg-ink text-white'
                : 'border-line bg-white text-ink/70 hover:border-ink/30 hover:text-ink',
            )}
          >
            {PRESET_LABELS[p]}
          </button>
        ))}
      </div>
      {value.preset === 'custom' ? (
        <div className="flex flex-wrap items-center gap-2 text-sm">
          <label className="flex items-center gap-2">
            <span className="text-ink/55">с</span>
            <input
              type="date"
              className="input !w-auto !py-1.5"
              value={value.from}
              max={value.to}
              onChange={(e) => e.target.value && onChange({ ...value, from: e.target.value })}
            />
          </label>
          <label className="flex items-center gap-2">
            <span className="text-ink/55">по</span>
            <input
              type="date"
              className="input !w-auto !py-1.5"
              value={value.to}
              min={value.from}
              max={today}
              onChange={(e) => e.target.value && onChange({ ...value, to: e.target.value })}
            />
          </label>
        </div>
      ) : null}
    </div>
  );
}
